const HEYREACH_BASE_URL = import.meta.env.VITE_HEYREACH_URL ?? 'https://outreach.seedforge.com'

const isMock = HEYREACH_BASE_URL.includes('localhost')

export const heyreach = {
  baseUrl: HEYREACH_BASE_URL,
  isMock,
  // Real HeyReach ignores the workspaceId query param (ops uses the top-right
  // workspace switcher); the mock interprets it and renders the clone page.
  // Same URL shape both ways keeps callers branchless.
  cloneCampaignUrl: (workspaceId: number) =>
    `${HEYREACH_BASE_URL}/app/campaigns?workspaceId=${workspaceId}`,
  linkedInAccountsUrl: (workspaceId?: number | null) =>
    workspaceId != null
      ? `${HEYREACH_BASE_URL}/app/linkedin-accounts?workspaceId=${workspaceId}`
      : `${HEYREACH_BASE_URL}/app/linkedin-accounts`,
  leadsUrl: (campaignId: number) => `${HEYREACH_BASE_URL}/app/my-list/${campaignId}?listType=0`,
  inboxUrl: (workspaceId: number) => `${HEYREACH_BASE_URL}/app/inbox?workspaceId=${workspaceId}`,
  // Fixed real-app URL (not VITE_HEYREACH_URL-based) — ops needs the actual
  // workspaces list to find and delete a workspace by the copied name.
  workspacesListUrl: 'https://app.heyreach.io/app/workspaces',
}
